"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpointageServicesMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class EpointageServicesMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const isLoading = lodash_1.default.get(result, "loading");
        const epointageServices = lodash_1.default.get(result, "data.list");
        return {
            hasError,
            isLoading,
            epointageServices,
        };
    }
}
exports.EpointageServicesMapper = EpointageServicesMapper;
